import {
  IsEnum,
  IsNotEmpty,
  IsNumber,
  IsString,
  isUUID,
  Max,
  Min,
  Validate,
  ValidationArguments,
  ValidatorConstraint,
  ValidatorConstraintInterface,
} from "class-validator";

export enum ProductListDiscountSection {
  PLACED = "PLACED",
  ADDITIONAL = "ADDITIONAL",
  DIRECT_BOM = "DIRECT_BOM",
  ATTACHMENT_INSTRUCTIONS = "ATTACHMENT_INSTRUCTIONS",
}

export enum ProductListDiscountSlot {
  MAIN = "MAIN",
  SENSOR = "SENSOR",
  ATTACHMENT = "ATTACHMENT",
  REGARD_BASE_UNIT = "REGARD_BASE_UNIT",
  REGARD_LID_UNIT = "REGARD_LID_UNIT",
  REGARD_INPUT_MODULE = "REGARD_INPUT_MODULE",
  REGARD_RELAY_MODULE = "REGARD_RELAY_MODULE",
  REGARD_GATEWAY_MODULE = "REGARD_GATEWAY_MODULE",
  REGARD_SLOT_COVER = "REGARD_SLOT_COVER",
  REGARD7000_DOCKING_STATION = "REGARD7000_DOCKING_STATION",
  REGARD7000_INPUT_MODULE = "REGARD7000_INPUT_MODULE",
  REGARD7000_RELAY_MODULE = "REGARD7000_RELAY_MODULE",
  REGARD7000_GATEWAY_MODULE = "REGARD7000_GATEWAY_MODULE",
  REGARD7000_TERMINAL_BLOCK = "REGARD7000_TERMINAL_BLOCK",
  REGARD7000_DASHBOARD = "REGARD7000_DASHBOARD",
  DIRECT_BOM_LINE = "DIRECT_BOM_LINE",
  PLACEHOLDER_PRODUCT = "PLACEHOLDER_PRODUCT",
}

@ValidatorConstraint({ name: "productListDiscountOwner", async: false })
class ProductListDiscountOwnerConstraint implements ValidatorConstraintInterface {
  validate(value: unknown, args: ValidationArguments): boolean {
    const discount = args.object as FgdsProductListDiscountDto;
    return discount.section === ProductListDiscountSection.ATTACHMENT_INSTRUCTIONS
      ? value === undefined
      : typeof value === "string" && isUUID(value);
  }

  defaultMessage(args: ValidationArguments): string {
    const discount = args.object as FgdsProductListDiscountDto;
    return discount.section === ProductListDiscountSection.ATTACHMENT_INSTRUCTIONS
      ? "ownerId must not be provided for attachment instructions"
      : "ownerId must be a valid UUID";
  }
}

export class FgdsProductListDiscountDto {
  @IsEnum(ProductListDiscountSection)
  section!: ProductListDiscountSection;

  @Validate(ProductListDiscountOwnerConstraint)
  ownerId?: string;

  @IsEnum(ProductListDiscountSlot)
  slot!: ProductListDiscountSlot;

  @IsString()
  @IsNotEmpty()
  productId!: string;

  @IsNumber({ allowInfinity: false, allowNaN: false })
  @Min(0)
  @Max(100)
  discount!: number;
}
